









import Vue from 'vue'
export default Vue.extend({
  name: 'SuccessMessage',
  props: ['success'],
  computed: {
    answer (): string {
      return this.$store.state.answer
    }
  },
  methods: {
    refresh () {
      this.$store.dispatch('refresh')
    }
  }
})
